var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-4"},[_c('b-row',[_c('b-col',{staticClass:"pb-5",attrs:{"cols":"8"}},[_c('section',[_c('h1',{staticClass:"titulo-contato"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"d-flex align-items-center col-10"},[_c('ContactForm')],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }